module.exports = __webpack_public_path__ + "static/media/AltCloseIcon.7d842e97.svg";